import styles from "./NavPanel.module.css";

const NavPanel = ({
  position='left',
  onClick
}) => {
  return (
    (position == 'full')  ?
      <div className={styles.full} onClick={onClick}> </div>
      :
      <div className={ `${ position == 'left' ? styles.leftNav : styles.rightNav }` } onClick={onClick}> </div>
  );
};

export default NavPanel;
